import { NotFound } from "@/lib/client/components/NotFound";
import type { ProductForClient } from "@/lib/shared/types/interfaces";
import { cn, Grid, Section } from "@/ui";
import { ProductCard } from "./ProductCard";

interface ProductsGridProps {
  products: ProductForClient[];
  className?: string;
  onProductClick?: () => void;
}

/**
 * ProductsGrid component.
 * Displays products in a grid layout.
 */
export const ProductsGrid = (props: ProductsGridProps) => {
  const { products, className, onProductClick } = props;

  return (
    <Section
      className={cn("px-0 py-4", className)}
      data-testid="products-grid"
    >
      {products && products.length > 0 ? (
        <Grid className="grid-cols-2 gap-x-2 gap-y-6 md:grid-cols-3 lg:grid-cols-4">
          {products.map((product) => (
            <ProductCard
              key={product.id}
              className="h-full justify-between"
              product={product}
              onProductClick={onProductClick}
            />
          ))}
        </Grid>
      ) : (
        <NotFound />
      )}
    </Section>
  );
};
